import { hubListAriaLabel } from '../../../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { Region, RegionBoundary, safeRender, AriaLandmark } from '../../..';
import HubListHeaderAsync from './../hubListHeader/hubListHeaderAsync';
import { default as HubListAsync, HubListProps } from '../hubList/hubListAsync';
import type { HubListHeaderProps } from '../hubListHeader/hubListHeaderAsync';

import styles from './hubListWithHeader.scss';

export type HubListWithHeaderProps = {
    /** This view takes precedence over the list, use it for loading views, error views, etc. */
    readonly alternateView?: JSX.Element;
    readonly extraHeaderContent?: JSX.Element;
} & HubListProps &
    HubListHeaderProps;

function hubListWithHeader(props: HubListWithHeaderProps): JSX.Element {
    const alternateView = props ? props.alternateView : null;
    const extraHeaderContent = props ? props.extraHeaderContent : null;

    return (
        <RegionBoundary
            region={Region.HubList}
            ariaLandmark={AriaLandmark.Navigation}
            ariaLabel={loc(hubListAriaLabel)}>
            <div className={styles.container}>
                <div className={styles.headerPlaceholder}>
                    <HubListHeaderAsync {...props} />
                    {extraHeaderContent}
                </div>
                {((props.entries && props.entries.length > 0) || props.sparseEntries) && (
                    <HubListAsync {...props} />
                )}
                {alternateView}
            </div>
        </RegionBoundary>
    );
}

export default safeRender(hubListWithHeader, 'HubListWithHeader');
